import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function CountdownPanel() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 rounded-xl border border-gold-300 bg-gold-50 px-6 py-5" data-id="element-39" data-mp="102n040etv4vp">
      <p className="inline-flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-gold-700" data-id="element-40" data-mp="l90bj7d4jn5q">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="c690v9s2ovf5" />
        La oferta de lanzamiento cierra en
      </p>
      <div className="flex items-start gap-6" role="timer" data-id="element-42" data-mp="h4agfkqaiclv">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-43" data-mp="26jgzlcj65r62">
            <span className="font-display text-3xl font-extrabold leading-none tracking-tight tabular-nums text-plum-700 md:text-4xl" data-id="element-44" data-mp="2bj3ahfbiyvbp">
              {unit.value}
            </span>
            <span className="mt-1.5 text-[0.6rem] font-bold uppercase tracking-[0.18em] text-muted" data-id="element-45" data-mp="1lf3yusikrkd1">
              {unit.label}
            </span>
          </div>)}
      </div>
    </div>;
}